import { type FC } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

interface DialogKonfirmasiUlangDinasProps
  extends Omit<DialogProps, 'children'> {
  onClick: () => void
  onClose: () => void
}

const DialogKonfirmasiUlangDinas: FC<DialogKonfirmasiUlangDinasProps> = ({
  onClick = () => {},
  onClose = () => {},
  ...props
}) => {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6 space-y-2">
          <Text variant="display-sm">
            Konfirmasi ulang data Dinas Pendidikan Anda
          </Text>

          <Text variant="body-lg" color="subdued">
            Data Dinas Pendidikan dibutuhkan untuk finalisisasi Predikat Kinerja
            Anda. Mohon segera konfirmasi ulang.
          </Text>

          <div className="flex gap-4 !mt-4">
            <Button size="lg" data-testid="btn-confirm" onClick={onClick}>
              Konfirmasi ulang
            </Button>
            <Button
              size="lg"
              variant="ghost"
              className="!px-1"
              onClick={onClose}
            >
              Tutup
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogKonfirmasiUlangDinas
